import React from 'react';
import Hammer from 'react-hammerjs';
import { DI } from 'modules';

import './style.css';

import Component from 'components/component';

const notEnoughMass = [
  '0',
  '50% + 15px',
  '33.33333% + 10px',
  '25% + 7.5px',
  '20% + 6px',
  '16.66666% + 5px',
  '14.28571% + 4.28571px',
  '12.5% + 3.75px',
  '11.11111% + 3.33333px',
  '10% + 3px',
  '9.09091% + 2.72727px',
  '8.33333% + 2.5px',
  '7.69231% + 2.30769px',
  '7.14286% + 2.14286px',
  '6.66666% + 2px',
  '6.25% + 1.875px',
  '5.88235% + 1.76471px',
  '5.55555% + 1.66666px',
  '5.26316% + 1.57895px',
  '5% + 1.5px',
];

export function _calcLeftOffset(
  currentSlide,
  maxSlides,
  width,
  notEnough,
  notEnoughMass,
  onPage,
  isSlider,
) {
  const px = width >= 700 ? (currentSlide * 30) : (isSlider ? currentSlide * 15 : 0);

  if (currentSlide === 0) {
    return 0;
  } else if (currentSlide === maxSlides - 1 && width >= 700) {
    return `calc(-${currentSlide * 100}% - ${px}px + ${notEnough}*(${notEnoughMass[onPage - 1]}))`;
  } else {
    return `calc(-${currentSlide * 100}% - ${px}px)`;
  }
}

class Slider extends Component {
  static defaultProps = {
    init: false,
    items: [],
    renderItem: (slide) => null,
    breakpoints: [],
    classNamePrefix: 'slider',
    hideDisabledButtons: true,
    infinity: false,
    autoScroll: 0,
    defaultInit: false,
  };

  state = {
    currentSlide: this.props.infinity ? this.props.items.length : 0,
    currentDot: 0,
    sliding: false,
    onPage: 1,
    maxSlides: 1,
    notEnough: 0,
    width: this.props.common.isMobile ? 0 : this.getWidth(),
    init: this.props.defaultInit,
  };

  getWidth() {
    return Math.max(
      typeof window !== 'undefined' ? window.innerWidth : 0,
      document.documentElement.clientWidth,
      document.body.clientWidth
    );
  }

  setAutoScroll = () => {
    this.autoscroll = setInterval(this.next, this.props.autoScroll);
  };

  removeAutoScroll = () => {
    clearInterval(this.autoscroll);
  };

  componentDidMount() {
    this.defineSettings(this.props, false);

    if (this.props.autoScroll) {
      this.setAutoScroll();
    }

    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate(prevProps) {
    const itemsReason = prevProps.items.length !== this.props.items.length;

    if (itemsReason) {
      this.defineSettings(this.props, false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = (ev) => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.defineSettings(this.props, true);
    }, 300);
  };

  defineSettings(props, saveSurrentSlide = false) {
    const state = {};
    const count = props.items.length;

    if (!saveSurrentSlide) {
      state.currentSlide = props.infinity ? props.items.length : 0;
    }

    state.onPage = 1;
    state.width = this.getWidth();

    for (let i = 0; i < props.breakpoints.length; i++) {
      const point = props.breakpoints[i];
      if (state.width >= point.width) {
        state.onPage = point.count;
        break;
      }
    }

    state.maxSlides = Math.ceil(count / state.onPage);
    state.notEnough = state.maxSlides * state.onPage - count;

    this.setState(state, () => {
      this.setState({
        init: true,
      });
    });
  }

  prev = (ev) => {
    if (ev) {
      this.removeAutoScroll();
    }
    if (!this.state.sliding) {
      let currentSlide = this.state.currentSlide;
      if (this.props.infinity) {
        if (currentSlide <= this.props.items.length) {
          this.setState({
            currentSlide: currentSlide - 1,
            sliding: true,
          });
          setTimeout(async () => {
            this.setState(
              {
                sliding: false,
                currentSlide:
                  this.state.currentSlide +
                  this.props.items.length,
              },
              ev ? this.setAutoScroll : undefined,
            );
          }, 500);
        } else {
          this.setState({
            currentSlide: currentSlide - 1,
            sliding: true,
          });
        }
      } else {
        this.setState({
          currentSlide: Math.min(
            Math.max(0, currentSlide - 1),
            this.state.maxSlides - 1,
          ),
          sliding: true,
        });
      }

      setTimeout(async () => {
        this.setState({
          sliding: false,
        });
      }, 500);
    }

    const isFirstItemDot = this.state.currentDot === 0;
    this.setState({
      currentDot: isFirstItemDot
        ? this.props.items.length - 1
        : this.state.currentDot - 1,
    });
  };

  next = (ev) => {
    if (ev) {
      this.removeAutoScroll();
    }
    if (!this.state.sliding) {
      let currentSlide = this.state.currentSlide;
      if (this.props.infinity) {
        if (currentSlide >= this.props.items.length * 2) {
          this.setState({
            currentSlide: currentSlide + 1,
            sliding: true,
          });
          setTimeout(async () => {
            this.setState(
              {
                sliding: false,
                currentSlide:
                  this.state.currentSlide -
                  this.props.items.length,
              },
              ev ? this.setAutoScroll : undefined,
            );
          }, 500);
        } else {
          this.setState({
            currentSlide: currentSlide + 1,
            sliding: true,
          });
        }
      } else {
        this.setState({
          currentSlide: Math.min(
            Math.max(0, currentSlide + 1),
            this.state.maxSlides - 1,
          ),
          sliding: true,
        });
      }

      setTimeout(async () => {
        this.setState({
          sliding: false,
        });
      }, 500);
    }

    const isLastItemDot =
      this.state.currentDot === this.props.items.length - 1;
    this.setState({
      currentDot: isLastItemDot ? 0 : this.state.currentDot + 1,
    });
  };

  clickOnDot = (index, ev) => {
    if (ev) {
      this.removeAutoScroll();
    }

    const itemsLength = this.props.items.length;
    const isFirstItemDot = index === 0;
    let newItemSlide = isFirstItemDot ? index + itemsLength : index;
    this.setState(
      {
        currentSlide: newItemSlide,
        currentDot: index,
        sliding: false,
      },
      ev ? this.setAutoScroll : undefined,
    );
  };

  render() {
    const { infinity, items, renderItem, classNamePrefix } = this.props;

    const { currentSlide, maxSlides } = this.state;

    const offset = _calcLeftOffset(
      this.state.currentSlide,
      this.state.maxSlides,
      this.state.width,
      this.state.notEnough,
      notEnoughMass,
      this.state.onPage,
      classNamePrefix === 'dashboard-slider'
      || classNamePrefix ===  'dashboard-live'
    );

    const scope = infinity ? [...items, ...items, ...items] : items;

    if (!items.length) {
      return null;
    }

    return (
      <Hammer
        onSwipeLeft={this.next}
        onSwipeRight={this.prev}
        direction="DIRECTION_HORIZONTAL"
      >
        <div
          className={this.classList(
            `${classNamePrefix}-outer _slider-outer`,
            this.state.init && '_init',
            this.state.sliding && '_sliding',
          )}
        >
          <div className={`${classNamePrefix}-prev`}>
            <div className={`${classNamePrefix}-prev-item`}>
              <div className={`${classNamePrefix}-prev-helper`}>
                {(infinity || currentSlide !== 0) && (
                  <button
                    type="button"
                    className={`${classNamePrefix}__prev`}
                    onClick={this.prev}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={`${classNamePrefix}-next`}>
            <div className={`${classNamePrefix}-next-item`}>
              <div className={`${classNamePrefix}-next-helper`}>
                {(infinity || currentSlide < maxSlides - 1) && (
                  <button
                    type="button"
                    className={`${classNamePrefix}__next`}
                    onClick={this.next}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={`${classNamePrefix}`}>
            <div
              className={`${classNamePrefix}-list`}
              style={{
                [this.props.common.locale === 'ar'
                  ? 'right'
                  : 'left']: offset,
              }}
            >
              {scope.map((item, index) => {
                return renderItem(
                  item,
                  index,
                  index === this.state.currentSlide ||
                  index ===
                  this.state.currentSlide -
                  items.length ||
                  index ===
                  this.state.currentSlide +
                  items.length,
                );
              })}
            </div>
            {classNamePrefix === 'dashboard-head' ? (
              <div
                className="dashboard-head-dots"
                style={{
                  [this.props.common.locale === 'ar'
                    ? 'right'
                    : 'left']: offset,
                }}
              >
                {items.map((item, index) => {
                  return (
                    <div
                      className={this.classList(
                        'dashboard-head-dot',
                        index ===
                        this.state.currentDot &&
                        '_active',
                      )}
                      data-id={index}
                      key={item.id + '-' + index}
                      style={{
                        [this.props.common.locale ===
                        'ar'
                          ? 'right'
                          : 'left']: offset,
                      }}
                      onClick={(ev) =>
                        this.clickOnDot(index, ev)
                      }
                    ></div>
                  );
                })}
              </div>
            ) : null}
          </div>
        </div>
      </Hammer>
    );
  }
}

export default DI()(Slider);
